import React, { Component } from 'react';

import About from 'components/general_panel/About';
import Load from 'components/general_panel/containers/LoadContainer';
import ModalBackground from 'components/general_panel/containers/ModalBackgroundContainer';
import ReportError from 'components/general_panel/containers/ReportErrorContainer';

import styles from './style';

export default class GeneralButton extends Component {
  render() {
    return (
      <div className={styles['container']}>
        <div className={styles['holder']}>
          <Load />
          <div className={styles['gap']} />
          <ReportError />
          <ModalBackground />
          <div className={styles['gap']} />
          <About />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/general_panel/GeneralPanel.jsx